<template>
    <div>
        <vs-prompt :title="$t('buttons.settings.btnText')" :active.sync="showSettings"
            :accept-text="$t('buttons.ok')"
            :cancel-text="$t('buttons.cancel')"
            :buttons-hidden="true"
            @accept="onClose"
            @close="onClose"
            @cancel="onClose">
            <div class="form-group">
                <vs-select :label="$t('buttons.settings.btnText')" v-model="myFilterPattern">
                    <vs-select-item
                        v-for="(item,index) in nomDropdownSettings.dropdownFilterPatternOptions"
                        :key="index"
                        :value="item.value"
                        :text="isEnVersion ? item.textEn : item.text"
                    />
                </vs-select>
            </div>
        </vs-prompt>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    props: {
        filterPattern: {
            type: String,
            required: true,
        },
        show: {
			type: Boolean,
			required: false
		}
    },
    data() {
        return {
            myFilterPattern: this.filterPattern,
            showSettings: false,
        };
    },
    methods: {
        onClose() {
            this.showSettings = false
            this.$emit("update:show", this.showSettings);
        },
    },
    computed: {
        ...mapGetters(['isEnVersion', 'claims', 'nomDropdownSettings']),
    },
    watch: {
		show: function(val) {
            if (val) {
                this.showSettings = val;
            }
        },
        myFilterPattern: function(val) {
            this.$emit("update:filterPattern", val);
        },
	}
};
</script>
